import { ISchemaObject } from '@augloop/types-core';

/**
 * Config for proofing workflows.
 */
export interface IProofingAnnotationActivationConfig extends ISchemaObject {
    /**
     * Indicates user's proofing languages as specified on the client.
     */
    ProofingLanguages?: string[];

    /**
     * Indicates user's license type.
     */
    LicenseType: LicenseType;

    /**
     * Indicates user's overridden critique type options on the client.
     */
    OverriddenCritiqueTypeOptions?: ICritiqueTypeOption[];
}

/**
 * Supported license type values.
 */
export enum LicenseType {
    NoLicense = 'NoLicense',
    Perpetual = 'Perpetual',
    Subscription = 'Subscription',
    SubscriptionPreview = 'SubscriptionPreview'
}

/**
 * Represents a critique type option.
 * Example: {LanguageId: "en-us", Id: "4ee98de6-ea40-48db-ae36-ca82fc8473f7", Name: "Academic Degrees", Value: "0"}
 */
 export interface ICritiqueTypeOption {
    /**
     * Critique type ID.
     */
    id: string;

    /**
     * The overridden value.
     */
    value: string;

    /**
     * Critique type language ID with variants.
     */
    languageId?: string;

    /**
     * Critique type name.
     */
    name?: string;

    /**
     * Value type name (e.g. System.Boolean).
     */
    typeName?: string;
}
